<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="topfrom" :lablewith="item.lablewith" :inputdata="item.inputdata"
						:title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:options="item.options" :width="item.width"></Commondropdownlist>
				</div>
				<div class="Btngroups">
					<CommonBtngroup :qhide="false" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox-flex">
				<div class="TableBox-l"
					style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;width:11.5%;margin-right:0.5%;height:500px;overflow-y:auto;">
					<div class="Province" style="padding:8px 6px;cursor: pointer;"
						:class="[current===item.Value?'current':'']" v-for="(item,index) in ProvinceList" :key="index"
						@click="handProvince(item)">
						{{item.Text}}
					</div>
				</div>
				<div class="TableBox"
					style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;width:88%;">
					<Productlinefiletable ref="protable" :tableData="tableData" :total="total" :proTitle="proTitle"
						:proCode="current" @handleCurrentChange="handleCurrentChange"
						@handleSizeChange="handleSizeChange" @export="handExport" @reload="getInventoryProvinceList">
					</Productlinefiletable>
				</div>
			</div>
			<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK"
				:src="'../assets/icon/icon-errors.png'">
				<span
					style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
			</Dialog>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import Productlinefiletable from './components/productlinefiletable.vue'
	import utils from '../../../common/utils'
	import {
		InventoryClassList,
	} from '@/api/home'
	import {
		GetInventoryProvinceList,
		GetProvinceRegion,
		ExportInventoryProvince,

	} from '@/api/newsapi'
	export default {
		components: {
			Commondropdownlist,
			Productlinefiletable,
			Dialog,
			CommonBtngroup
		},
		data() {
			return {
				current: '',
				proTitle: '', //省份中文名
				ProvinceList: [],
				dialogVisibles: false,
				showorhide: true,
				total: 1,
				pageindex: 1,
				pageSize: 10,
				tableData: [],
				invAddCode: '',
				invName: '',
				invClass: '',
				formdata: [{
						inputdata: '',
						title: '产品型号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '70px'
					},
					{
						inputdata: '',
						title: '产品名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px'
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						inputtype: 'select',
						options: [],
						width: '210px',
						lablewith: '110px'
					},
				]
			}
		},
		mounted() {
			this.getProvinceRegion();
			this.inventoryClassList();
		},
		methods: {
			handProvince(e) {
				this.current = e.Value;
				this.proTitle = e.Text;
				this.getInventoryProvinceList();
			},
			//获取省份
			async getProvinceRegion() {
				let {
					data,
					code
				} = await GetProvinceRegion({})
				if (code == 0) {
					this.ProvinceList = data;
					if (data && data.length) {
						this.current = data[0].Value;
						this.proTitle = data[0].Text;
						this.getInventoryProvinceList();
					}
				}
			},
			// 获取产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.formdata[2].options = []
					data.data.map((item, index) => {
						this.formdata[2].options.push({
							key: item.InvClass,
							value: item.InvClassName
						})
					})
				}
			},
			async getInventoryProvinceList() {
				let {
					data,
					code
				} = await GetInventoryProvinceList({
					invClass: this.invClass,
					invName: this.invName,
					invAddCode: this.invAddCode,
					provinceID: this.current,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				//console.log(code, data)
				if (code == 0) {
					this.total = data.Count
					if (data.data) {
						this.tableData = data.data;
					}
				}
			},
			//导出数据
			async handExport() {
				let resexprot = await ExportInventoryProvince({
					invClass: this.invClass,
					invName: this.invName,
					invAddCode: this.invAddCode,
					provinceID: this.current,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `集采产品省份关系${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
			},
			//
			reset() {
				this.$refs.topfrom.map((item, index) => {
					item.modelvalue = ''
				})
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				this.dialogVisibles = false
			},
			hide() {
				this.showorhide = false
			},
			select() {
				this.pageindex = 1
				this.invAddCode = this.$refs.topfrom[0].modelvalue
				this.invName = this.$refs.topfrom[1].modelvalue
				this.invClass = this.$refs.topfrom[2].modelvalue
				this.getInventoryProvinceList()
			},
			showclick() {
				this.showorhide = true
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.getInventoryProvinceList()
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.getInventoryProvinceList()
			},
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 10px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 350px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 45px;
	}

	.TableBox-flex {
		display: flex;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 30px;
	}

	.current {
		background: #fce8ec;
		transition: all linear 0.5s;
	}
</style>